import { supabase } from "services/supabaseClient";

export const ISSUE_DOCUMENT_TYPES = [
  { value: "official_statement", label: "Official Statement" },
  { value: "preliminary_official_statement", label: "Preliminary Official Statement" },
  { value: "notice_of_sale", label: "Notice of Sale" },
  { value: "continuing_disclosure", label: "Continuing Disclosure" },
  { value: "rating_report", label: "Rating Report" },
  { value: "financing_document", label: "Financing Document" },
  { value: "other", label: "Other" },
];

export function issueDocumentTypeLabel(value) {
  return ISSUE_DOCUMENT_TYPES.find((option) => option.value === value)?.label || value || "Other";
}

export function canDeleteIssueDocument({ document, deal, profile }) {
  if (!document || !deal || !profile) return false;
  if (profile.is_admin) return true;
  const dealClass = String(deal.dealClass ?? deal.deal_class ?? "org").toLowerCase();
  return dealClass === "org" && (
    document.created_by === profile.id || deal.created_by === profile.id
  );
}

function safeFileName(name = "document") {
  return String(name).replace(/[^a-zA-Z0-9._-]+/g, "-").replace(/^-+|-+$/g, "") || "document";
}

export async function fetchIssueDocuments(dealId) {
  const { data, error } = await supabase
    .from("record_doc_scopes")
    .select("record_docs(id,title,doc_type,description,file_path,created_at,created_by)")
    .eq("ds_deal_id", dealId)
    .order("id", { ascending: false });
  if (error) throw error;
  return (data || []).map((row) => row.record_docs).filter(Boolean)
    .sort((a, b) => String(b.created_at).localeCompare(String(a.created_at)));
}

export async function uploadIssueDocument({ dealId, tenantId, title, docType, description, file }) {
  const docId = globalThis.crypto.randomUUID();
  const prefix = tenantId || "library";
  const filePath = `${prefix}/debt-studio/${dealId}/${docId}/${safeFileName(file.name)}`;

  const { data: doc, error: createError } = await supabase.rpc("create_ds_deal_document", {
    p_deal_id: dealId,
    p_doc_id: docId,
    p_title: title,
    p_doc_type: docType,
    p_description: description || null,
    p_file_path: filePath,
  });
  if (createError) throw createError;

  const { error: uploadError } = await supabase.storage
    .from("record_docs_files")
    .upload(filePath, file, { contentType: file.type || "application/octet-stream" });

  if (uploadError) {
    await supabase.rpc("delete_ds_deal_document", { p_doc_id: docId });
    throw uploadError;
  }
  return doc;
}

export async function deleteIssueDocument(document) {
  const { error: storageError } = await supabase.storage
    .from("record_docs_files")
    .remove([document.file_path]);
  if (storageError) throw storageError;

  const { error } = await supabase.rpc("delete_ds_deal_document", { p_doc_id: document.id });
  if (error) throw error;
}
